export const routes = {
    LINKEDIN: 'linkedIn'
}